import { render, staticRenderFns } from "./bi-quote-summary.vue?vue&type=template&id=1b8960f0&"
import script from "./bi-quote-summary.vue?vue&type=script&lang=ts&"
export * from "./bi-quote-summary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports